export default class BEM {
    static element_class(baseClass, modifier) {
        return `${baseClass}__${modifier}`;
    }

    static modifier_class(baseClass, modifier) {
        return `${baseClass}--${modifier}`;
    }
}
